import { SVGProps, Ref, forwardRef } from 'react';

export const ChevronLeftSquareFilledSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 23q-1.123.001-2.1-.028V1.028Q10.877 1 12 1c9.625 0 11 1.375 11 11s-1.375 11-11 11M1 12c0-8.136.982-10.377 7.1-10.876v21.752C1.982 22.377 1 20.136 1 12m15.364-3.636L12.727 12l3.637 3.637 1.272-1.273L15.273 12l2.363-2.364z"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
ChevronLeftSquareFilledSize24Glyph.displayName = 'ChevronLeftSquareFilledSize24Glyph';
